// src/components/ParticipantBadge/index.tsx
import React from "react";
import styles from "./index.module.css";

// We'll expect you to provide the icon path yourself,
// e.g., in your local assets or as an import.
interface ParticipantBadgeProps {
  count?: number;
  iconSrc: string; // local path for your icon
}

const ParticipantBadge: React.FC<ParticipantBadgeProps> = ({
  count = 2,
  iconSrc,
}) => {
  return (
    <div className={styles.participationBadge}>
      <img
        src={iconSrc}
        alt="Participants"
        className={styles.participantIcon}
      />
      <span className={styles.participantNumber}>{count}</span>
    </div>
  );
};

export default ParticipantBadge;
